import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Edge } from '../Edge/Edge';
import { FlowType, GroupItem } from '../../../../api/useEstatePlanningFlowQuery';
import { Nodes } from '../Nodes/Nodes';
import { GradientMask, GroupContent } from './Group.styles';
import { Direction, NavigationButtons } from './components/NavigationButtons/NavigationButtons';
import { AnimationParent } from './components/AnimationParent/AnimationParent';

interface Props {
  groupItems: GroupItem[];
}

export const Group = ({ groupItems }: Props) => {
  const [isInitialPosition, setIsInitialPosition] = useState(true);

  return (
    <Box position="relative">
      <GradientMask />

      <GroupContent>
        {groupItems.length > 1 && (
          <NavigationButtons
            direction={isInitialPosition ? Direction.Right : Direction.Left}
            onClick={() => {
              setIsInitialPosition(!isInitialPosition);
            }}
          />
        )}

        {groupItems.map((groupData, groupDataIndex) => {
          return (
            <AnimationParent
              key={groupDataIndex}
              isLeftSideElement={groupDataIndex === 0}
              isInitialPosition={isInitialPosition}
            >
              <Box as={motion.div} display="flex" flexDirection="column" layout>
                {groupData.title && <Edge label={groupData.title} showTopLine={false} />}

                {groupData.items.map((item, flowDataItemsIndex) => {
                  const isLast = flowDataItemsIndex + 1 === groupData.items.length;

                  if (item.type === FlowType.Edge) {
                    return (
                      <Edge
                        key={flowDataItemsIndex}
                        title={item.title}
                        value={item.value}
                        additionalInfo={item.additionalInfo}
                      />
                    );
                  }

                  return <Nodes key={flowDataItemsIndex} items={item.items} isLast={isLast} />;
                })}
              </Box>
            </AnimationParent>
          );
        })}
      </GroupContent>
    </Box>
  );
};
